// categories_data.ts

export const categories = [
  {
    key: 'modeling',
    title: 'categories.modeling.title',
    image: `${process.env.PUBLIC_URL}/icon/modeling.png`,
    link: '/products/modeling',
    gradient: 'linear-gradient(135deg, #FFCB52, #FF7B02)',
    size: 'small',
    imagePosition: 'bottom-left-css',
    overflowHidden: true,
    textPosition: '',
        textColor: '#8a3600',
  },
  {
    key: 'architecture',
    title: 'categories.architecture.title',
    image: `${process.env.PUBLIC_URL}/icon/build.png`,
    link: '/products/building',
    gradient: 'linear-gradient(135deg,  #f286a0, #e95f62)',
    size: 'small',
    imagePosition: 'bottom-css',
    textPosition: '',
        textColor: '#9a1E1E ',
    overflowHidden: true,
  },
  {
    key: 'entity',
    title: 'categories.entity.title',
    image: `${process.env.PUBLIC_URL}/icon/entity.png`,
    link: '/products/entity',
    gradient: 'linear-gradient(135deg, #fbf7b8, #97f7f5)', // 민트 그라데이션
    size: 'large',
    imagePosition: 'bottom-css',
    overflowHidden: true,
    textPosition: 'right',
    textColor: '#35524A',
  },
  {
    key: 'pixel',
    title: 'categories.pixel.title',
    image: `${process.env.PUBLIC_URL}/icon/pixel.png`,
    link: '/products/pixel',
    gradient: 'linear-gradient(135deg, #c4eaf3, #87b7e8)', // 블루 그라데이션
    size: 'large',
    imagePosition: 'top-left',
    overflowHidden: true,
    textPosition: 'right',
    textColor: '#2A3A4D',
  },
  {
    key: 'free',
    title: 'categories.free.title',
    image: `${process.env.PUBLIC_URL}/icon/free.png`,
    link: '/products/free',
    gradient: 'linear-gradient(135deg, #fff6b7, #f6416c)', // 핑크-오렌지 그라데이션
    size: 'small',
    imagePosition: 'top-left',
    overflowHidden: true,
    textPosition: 'right',
    textColor: '#9b1E1E',
  },
  {
    key: 'script',
    title: 'categories.script.title',
    image: `${process.env.PUBLIC_URL}/icon/script.png`,
    link: '/products/script',
    gradient: 'linear-gradient(135deg, #dfe4ef, #899cfc)', // 청록색 그라데이션
    size: 'small',
    imagePosition: 'top-left',
    overflowHidden: false,
    textPosition: 'right',
    textColor: '#2E3A59',
  },
  {
    key: 'skin',
    title: 'categories.skin.title',
    image: `${process.env.PUBLIC_URL}/icon/skin.png`,
    link: '/products/skin',
    gradient: 'linear-gradient(135deg, #dff7df, #98f286)', //
    size: 'small',
    imagePosition: 'top-left',
    overflowHidden: true,
    textPosition: 'right',
    textColor: '#2E4A2A',
  },
  {
    key: 'skill',
    title: 'categories.skill.title',
    image: `${process.env.PUBLIC_URL}/icon/skill.png`,
    link: '/products/skill',
    gradient: 'linear-gradient(135deg, #dde0fa, #f0cbf6)', // 청록색 그라데이션
    size: 'small',
    imagePosition: 'top-left',
    overflowHidden: true,
    textPosition: 'right',
    textColor: '#3A2A47',
  },
  {
    key: 'plugin',
    title: 'categories.plugin.title',
    image: `${process.env.PUBLIC_URL}/icon/plugin.png`,
    link: '/products/plugin',
    gradient: 'linear-gradient(135deg, #e8f0f7, #87b7e8)',
    size: 'large',
    imagePosition: 'bottom-left',
    overflowHidden: true,
    textPosition: 'right',
    textColor: '#2C3E50',
  },
];
